module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-form', {
    ref: "loginForm",
    staticClass: "login-container",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("宜春邮政快递业安全监管系统")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "loginName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.loginForm.loginName),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "loginName", $$v)
      },
      expression: "loginForm.loginName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleLogin.apply(null, arguments)
      }
    }
  }, [_vm._v("登录")])], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "myfoot"
    }
  }, [_vm._v("\n    ©2026 宜春市邮政管理局 版权所有"), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#333"
    },
    attrs: {
      "href": "http://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("赣ICP备2026000945号-1")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45a12af0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 828
// module chunks = 2